var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-btn-container"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/download.svg")}}),_c('span',{staticClass:"text",on:{"click":_vm.download}},[_vm._v("Download Template")]),_c('loading-animation',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoader),expression:"showLoader"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }